<template>
  <div class="form-group">
    <h4 class="text-header form-section__title">
      {{ $t('step3.physicianDetails') }}
    </h4>
    <p class="form-section__description">
      {{ $t('step3.physicianDesc') }}
    </p>
    <div
      v-if="$formData.policyDetails.policyHolderInsured"
      class="row g-3"
    >
      <div class="col-md-12">
        <div class="form-check form-check-inline">
          <div>
            <input
              :id="'PhysicianSameAsPolicyHolder' + memberIndex"
              v-model="form.physicianSamePolicyHolder"
              class="form-check-input"
              type="checkbox"
              name="FamilyMember.ConfirmChecked"
              @change="clone(form.physicianSamePolicyHolder)"
            >
            <label
              :for="'PhysicianSameAsPolicyHolder' + memberIndex"
              class="form-check-label"
            >
              <span
                v-for="(item, index) in $root.t('common.samePolicy')"
                :key="index"
              >
                {{ item }} <br>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <PhysicalDetailsForm
      :form-data="form"
      :prefix="'member' + memberIndex"
    />
  </div>
</template>
<script>
import PhysicalDetailsForm from '../Form/PhysicalDetailsForm.vue'
import { setDefaultPhysicianDetail } from '../../../data/formData.js'

export default {
  name: 'PhysicianDetailsByFamily',
  components: {
    PhysicalDetailsForm,
  },
  props: {
    familyData: { type: Object, required: true },
    memberIndex: { type: Number, required: true },
  },
  data() {
    return {
      isExistingHealthInsurancePolicies: false,
      coverEndDate: null,
      providerCompanyName: '',
      form: this.familyData.additionalDetails.physicianDetails,
      physicianDetails: this.$formData.policyHolder.additionalDetails.physicianDetails,
    }
  },
  mounted() {},
  methods: {
    clone(status) {
      if (status === true) {
        const policyHolderPhysicalDetails = this.physicianDetails
        let currentInsurance = {
          insuranceProvider: this.form.insuranceProvider,
          haveExistingHealthInsurance: this.form.haveExistingHealthInsurance,
        }

        Object.assign(this.form, policyHolderPhysicalDetails)
        this.form.currentInsurance = currentInsurance.currentInsurance
        this.form.haveExistingHealthInsurance = currentInsurance.haveExistingHealthInsurance

        // this.form = {insuranceProvider ,policyHolderPhysicalDetails}
        this.form.address = { ...policyHolderPhysicalDetails.address }
      } else {
        this.form = setDefaultPhysicianDetail()
      }
    },
  },
}
</script>
